import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { SoundToggleButton } from './soundToggleButton';
import { SoundVolumeSlider } from './soundVolumeSlider';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  margin: 5px;
  padding: 5px 10px;
  overflow-x: hidden;
`;
export const SoundControl = () => {
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(SoundToggleButton, {}), _jsx(SoundVolumeSlider, {})] }));
};
